import cn from 'classnames';
import React, {FC} from 'react';
import ReactContentLoader, {IContentLoaderProps} from 'react-content-loader';

import styles from './ContentLoader.module.css';

const FROM_COLOR = 'rgba(0, 0, 0, 0.02)';
const TO_COLOR = 'rgba(0, 0, 0, 0.04)';

export const ContentLoader: FC<IContentLoaderProps> = ({className, ...restProps}) => (
	<ReactContentLoader
		className={cn(styles.root, className)}
		primaryColor={FROM_COLOR}
		secondaryColor={TO_COLOR}
		{...restProps}
	/>
);
